import React, { useState, useRef, useEffect } from "react";
import "../styles/LearningRoomNeedHelpStyles.css";
import CloseButton from "../../dashboard/assets/needhelp/dashNeedHelpClose.svg";
import MailImg from "../../dashboard/assets/needhelp/dashboardmailimg.svg";
import scrollicon from "../../dashboard/assets/needhelp/scrollIcon.png";
import ScrollDownButton from "../../dashboard/assets/needhelp/downArrow.png";
import faqIcon from "../../dashboard/assets/needhelp/faqIconBgWhite.png";
import { ContentWrapper } from "../../dashboard/components/ProgramScheduelNeedHelp";
import { QuestionHeader } from "../../dashboard/components/NeedHelpOverAllProgress";
import strings from "../../../utils/Strings";
import AccessImg from "../assets/needhelp/access.png";
import IncludeImg from "../assets/needhelp/include.png";
import DiscussImg from "../assets/needhelp/discuss.png";

export interface RightModalProps {
  isOpen?: boolean;
  toggleModal?: () => void;
}

const LearningRoomNeedHelpRightModal: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const [activeQuestion, setActiveQuestion] = useState<
    null | "access" | "discuss" | "included"
  >(null);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const progressCardRef = useRef<HTMLDivElement | null>(null);

  // Scroll to top function
  const [isAtTop, setIsAtTop] = useState(false);
  const [isbuttonShow, setIsbuttonShow] = useState(true);

  // Scroll Up
  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Scroll Down
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  // Track container scroll
  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        setIsAtTop(containerRef.current.scrollTop < 50);
      }
    };

    const current = containerRef.current;
    current?.addEventListener("scroll", handleScroll);

    return () => current?.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      {isOpen && (
        <div className="learningroom-needhelp-overlay" onClick={toggleModal} />
      )}
      <div
        className={`learningroom-needhelp-right-modal ${isOpen ? "open" : ""}`}
      >
        {/* Dashboard Need Help Header */}
        <div className="learningroom-needhelp-header">
          <div className="learningroom-needhelp-headerrow">
            <img src={faqIcon} alt="contact-button" />
            <h4>Need help?</h4>
          </div>
          <div className="learningroom-needhelp-header-end">
            <div className="learningroom-needhelp-contact-header">
              <img
                src={MailImg}
                className="learningroom-needhelp-contact-image"
                alt="contact-button"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              />
              <div
                className="learningroom-needhelp-contact-text"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              >
                Get Support
              </div>
            </div>
            <img
              src={CloseButton}
              className="dashboardv2-close"
              onClick={toggleModal}
              alt="close-button"
            />
          </div>
        </div>
        {/* Dashboard Need Help Body Top */}
        <div className="learningroom-needhelp-content"></div>

        {/* Divider */}
        <div
          className="learningroom-needhelp-horizontal-divider"
          style={{
            marginLeft: "15px",
            marginRight: "15px",
            height: "2px",
            backgroundColor: "#C2D3F6",
          }}
        ></div>
        <div
          ref={containerRef}
          style={{
            overflow: "auto",
            height: "700px",
            scrollBehavior: "smooth",
            marginBottom: "20px",
          }}
        >
          {/* First Question */}
          {activeQuestion === "access" ? (
            <ContentWrapper
              question={strings.learningRoomNeedHelp.accessQus}
              onClose={() => setActiveQuestion(null)}
            >
              <div className="learningroom-overallprogressContainer">
                <div className="learningroom-overallprogress-left-column">
                  <div
                    className="learningroom-needhelpOPcardtext"
                    ref={progressCardRef}
                  >
                    {/* <p>{strings.needHelp.overAllProgressCardTxt}</p> */}
                    <p>{strings.learningRoomNeedHelp.accessAns}</p>
                  </div>
                  <img
                    src={AccessImg}
                    style={{
                      height: "75%",
                      width: "100%",
                      // objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </ContentWrapper>
          ) : (
            <QuestionHeader
              text={strings.learningRoomNeedHelp.accessQus}
              onClick={() => {
                setIsbuttonShow(false);
                setActiveQuestion("access");
              }}
            />
          )}
          {/* Second Question */}
          {activeQuestion === "discuss" ? (
            <ContentWrapper
              question={strings.learningRoomNeedHelp.discussQus}
              onClose={() => setActiveQuestion(null)}
            >
              <div className="learningroom-overallprogressContainer">
                <div className="learningroom-overallprogress-left-column">
                  <div
                    className="learningroom-needhelpOPcardtext"
                    ref={progressCardRef}
                  >
                    {/* <p>{strings.needHelp.overAllProgressCardTxt}</p> */}
                    <p>{strings.learningRoomNeedHelp.discussAns}</p>
                  </div>
                </div>
                <div className="learningroom-overallprogress-right-column">
                  {" "}
                  <img
                    src={DiscussImg}
                    style={{
                      height: "90%",
                      width: "100%",
                      // objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </ContentWrapper>
          ) : (
            <QuestionHeader
              text={strings.learningRoomNeedHelp.discussQus}
              onClick={() => {
                setIsbuttonShow(false);
                setActiveQuestion("discuss");
              }}
            />
          )}
          {/* Thrid Question */}
          {activeQuestion === "included" ? (
            <ContentWrapper
              question={strings.learningRoomNeedHelp.includeQus}
              onClose={() => setActiveQuestion(null)}
            >
              <div className="learningroom-overallprogressContainer">
                <div
                  className="learningroom-overallprogress-left-column"
                  style={{ flex: 3 }}
                >
                  <div
                    className="learningroom-needhelpOPcardtext"
                    ref={progressCardRef}
                  >
                    {/* <p>{strings.needHelp.overAllProgressCardTxt}</p> */}
                    <p>{strings.learningRoomNeedHelp.includeAns}</p>
                  </div>
                </div>
                <div
                  className="learningroom-overallprogress-right-column"
                  style={{ flex: 2 }}
                >
                  {" "}
                  <img
                    src={IncludeImg}
                    style={{
                      height: "100%",
                      width: "100%",
                      // objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </ContentWrapper>
          ) : (
            <QuestionHeader
              text={strings.learningRoomNeedHelp.includeQus}
              onClick={() => {
                setIsbuttonShow(false);
                setActiveQuestion("included");
              }}
            />
          )}

          {isOpen && (
            <div
              onClick={isAtTop ? scrollToBottom : scrollToTop}
              style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                backgroundColor: "#B8BDc7",
                color: "#333333",
                fontWeight: 500,
                fontSize: "13px",
                boxShadow: "0px 1px 5px 0px #00000040",
                width: isAtTop ? "110px" : "100px",
                borderRadius: "18px",
                padding: "8px 8px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                paddingLeft: 0,
                paddingRight: 0,
                zIndex: 9999, // ✅ ensures it's above other content
              }}
            >
              {isAtTop ? (
                <>
                  Scroll Down{" "}
                  <img
                    src={ScrollDownButton}
                    alt="scroll-down"
                    style={{ height: "20px", width: "20px" }}
                  />
                </>
              ) : (
                <>
                  Scroll Up{" "}
                  <img
                    src={scrollicon}
                    alt="scroll-up"
                    style={{ height: "20px", width: "20px" }}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LearningRoomNeedHelpRightModal;
